import types from 'store/types/order';
import Requester from '../../helpers/requester';
import { API_PATHS } from '../../helpers/endpoints';
import { HTTP_METHODS } from 'helpers/constants';
import { completedOrderManually, getOrderHistory } from '../requests/order';

export default {
  getOrdersFromShipment: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDERS_SEARCH}?${queryString}`,
      });
      const { _embedded } = response;
      dispatch({
        type: types.ORDER_SET,
        key: 'orders',
        data: _embedded ? _embedded.orderResponseDtoList : [],
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  courierAssignments: (payload) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_ASSIGNMENT}/change-courier`,
        data: payload,
      });
      dispatch({
        type: types.ORDER_SET,
        key: 'courierAssignment',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOrderById: (orderId) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDERS_DETAIL}/${orderId}`,
      });

      dispatch({
        type: types.ORDER_SET,
        key: 'selectedOrder',
        data: response.data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getOrderItemProperties: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDER_ITEM_PROPERTIES_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editOrderItemProperties: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.ORDER_ITEM_PROPERTIES}/${data.id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOrdersLocations: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDERS_LOCATIONS}`,
        data: data,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  cancelOrderManually: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.ORDERS}/${id}/cancel-order-manually`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  deliverOrderManually: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.ORDERS}/${id}/deliver-order-manually`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  notDeliverOrderManually: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.ORDERS}/${id}/not-deliver-order-manually`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  completedOrderManually: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.ORDERS}/${id}/complete-order-manually`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getOrderHistory: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.ORDER_HISTORY}?filter=order.id==${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderTransfer: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDERS_TRANSFER}`,
        data: data,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  getZonesWithCurrentSlot: async (storeId) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ZONES_WITH_SLOT}/${storeId}/with-current-slot?page=0&size=2000`,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  getWaitingCancelItems: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDER_ITEM}/waiting-cancel-items?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCancellationReason: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDER_ITEM}/cancellation-reason`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  approveCancelOrder: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDER_ITEM}/approve-cancel`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getOrdersWaitingTransfer: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.WAITING_TRANSFER_ORDER}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderMapDetail: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDER_MAP}/order-detail`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderMapStoresPolygon: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDER_MAP}/stores-in-polygon`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderPolygonDetail: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDER_MAP}/search?page=0&size=500`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderPolygonSave: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDER_MAP}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderPolygonEdit: async (data, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.ORDER_MAP}/${id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderPolygonDelete: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.ORDER_MAP}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  orderPolygonParameter: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PARAMETER_SETTINGS}/search?filter=parameterCode==${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
   getStoreCourierSource: async (queryString) => {
      try {
        const response = await Requester.submit({
          url: `${API_PATHS.STORE_COURIER_SOURCES}/search?&${queryString}`,
        });
        return response;
      } catch (error) {
        throw error;
      }
    },
  
    deleteStoreCourierSource: async (id) => {
      try {
        const response = await Requester.submit({
          method: HTTP_METHODS.DELETE,
          url: `${API_PATHS.STORE_COURIER_SOURCES}/inactive/${id}`,
        });
        return response;
      } catch (error) {
        throw error;
      }
    },
  
    addStoreCourierSource: async (payload) => {
      try {
        const response = await Requester.submit({
          method: HTTP_METHODS.POST,
          url: `${API_PATHS.STORE_COURIER_SOURCES}`,
          data: payload,
        });
        return response;
      } catch (error) {
        throw error;
      }
    },
  
    getCourierSource: async () => {
      try {
        const response = await Requester.submit({
          url: `${API_PATHS.COURIER_SOURCES}/search`,
        });
        return response;
      } catch (error) {
        throw error;
      }
    },
  
    editStoreCourierSource: async (payload) => {
      try {
        const response = await Requester.submit({
          method: HTTP_METHODS.PUT,
          url: `${API_PATHS.STORE_COURIER_SOURCES}`,
          data: payload,
        });
        return response;
      } catch (error) {
        throw error;
      }
    },

  orderExportDetail: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDER_MAP}/export/order-detail`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

};
